module.exports = __webpack_public_path__ + "img/qr-loading.dafb7c92.gif";